const { format } = require('date-fns')
const { EntityApi } = require('../common')
const SupplyPlanPgAdapter = require('./data-access/supply-plan-pg-adapter')

class SupplyPlanApi extends EntityApi {
  constructor (state, pgConnection, logger) {
    super((pgConnection && new SupplyPlanPgAdapter(pgConnection, state.user, logger)) || {})
    this.state = state
    this.pgConnection = pgConnection
  }

  async get ({ program, sku, locationType, date } = {}) {
    if (!program || !sku || !locationType) {
      const err = new Error('program, sku and locationType are required')
      err.status = 400
      throw err
    }
    return this.adapter.getLatest({ programFsid: program, sku, locationType, date })
  }

  async list ({ program, date } = {}) {
    if (!program) {
      const err = new Error('program is required')
      err.status = 400
      throw err
    }
    return this.adapter.listLatest({ programFsid: program, date })
  }

  async getLatestBatch (tuples) {
    return this.adapter.getLatestBatch(tuples)
  }

  async update (params) {
    const rows = Array.isArray(params) ? params : [params]
    if (!rows.length) return []

    const today = format(new Date(), 'YYYY-MM-DD')
    const required = ['program', 'sku', 'locationType', 'supplyPeriodDays', 'leadTimeDays']
    for (const row of rows) {
      for (const field of required) {
        if (row[field] === undefined || row[field] === null || row[field] === '') {
          const err = new Error(`Missing required field "${field}" in supply plan param: ${JSON.stringify(row)}`)
          err.status = 400
          throw err
        }
      }
      if (!row.date) row.date = today
    }
    return this.adapter.insertMany(rows)
  }
}

module.exports = SupplyPlanApi
